import Paytable from '../model/paytable';

/**
 * Paytable service
 * @type {{init: (function()), getPaytableSvc: (function())}}
 */
export const PaytableSvc = {
  /**
   * Initialize paytable service
   */
  init() {
    this.paytableSvc = new Paytable();
  },

  /**
   * Get paytable service
   * @returns {Paytable|PaytableSvc}
   */
  getPaytableSvc() {
    return this.paytableSvc;
  },
};



// WEBPACK FOOTER //
// paytable.service.js